import { initializeApp, FirebaseApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, Messaging } from 'firebase/messaging';
import { Capacitor } from '@capacitor/core';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

let app: FirebaseApp | null = null;
let messaging: Messaging | null = null;

/**
 * Initialize Firebase for web push notifications.
 * Only initializes on web platform (not native iOS/Android).
 */
export function initializeFirebase(): Messaging | null {
  if (Capacitor.isNativePlatform()) {
    return null;
  }

  if (!app) {
    app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
  }

  return messaging;
}

export function getFirebaseMessaging(): Messaging | null {
  return messaging;
}

export { getToken, onMessage };
export type { Messaging };
